<template>
  <div class="booking" v-loading="pageLoading">
    <!-- <div class="auditbox" v-if="pageType == 2">
      <div class="header">
        <span class="none">审核状态</span>
        <span class="none" style="margin-left: 50px">修改建议</span>
      </div>
      <div class="content">
        <el-button v-if="pageDetail.status == 0" type="warning" size="small" plain>待审核</el-button>
        <el-button v-if="pageDetail.status == 6" type="danger" size="small" plain style="width: 68px;">拒接</el-button>
        <div>
          <el-input type="textarea" :rows="2" placeholder="暂无信息" :disabled="true" v-model="pageDetail.reason">
          </el-input>
        </div>
      </div>
    </div> -->
    <div style="margin-top:20px" v-if="pageType == 2 && pageDetail.creator == USER_INFO.id"></div>
    <el-row type="flex" class="row-bg" justify="end" v-if="pageType == 2 && pageDetail.creator == USER_INFO.id">
      <template v-if="pageDetail.status == 0">
        <el-button size="small" type="primary" v-if="pagedisabled" @click="pagedisabled = false">编辑</el-button>
        <el-button size="small" type="primary" v-if="!pagedisabled"
          @click.native.prevent="handleSubmit('edit')">保存</el-button>
      </template>
      <template v-if="pageDetail.status == 6">
        <el-button size="small" type="primary" @click.native.prevent="reBooking()">重新订舱</el-button>
      </template>
      <template>
        <el-button size="small" type="primary" plain @click.native.prevent="$router.back()">返回</el-button>
      </template>
    </el-row>
    <template v-else>
      <div style="margin-top: 20px;"></div>
      <el-row type="flex" class="row-bg booking-header" justify="space-between">
        <div class="booking-title">
          <span>{{ wholeType === 1 ? '整箱订舱' : '拼箱订舱' }}</span>
        </div>
        <div>
          <el-button 
            size="small" 
            type="primary" 
            @click="switchBookingType"
          >
            {{ wholeType === 1 ? '切换拼箱订舱' : '切换整箱订舱' }}
          </el-button>
          <el-button size="small" type="primary" plain @click.native.prevent="$router.back()">返回</el-button>
        </div>
      </el-row>
    </template>
    <div class="card">
      <div class="header">
        <span class="sign"></span>
        客户信息
      </div>
      <el-form label-width="170px" ref="baseform" :model="baseform" :rules="rules" :disabled="pagedisabled"
        label-position="left" style="padding-top:20px; width: 1200px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="委托单位" prop="company_id">
              <el-select 
                v-model="baseform.company_id" 
                placeholder="请选择所属公司" 
                filterable 
                remote
                :remote-method="getCompanyListByKeyword"
                :loading="companyLoading"
                :clearable="false" 
                @change="getCustomerList" 
                size="small" 
                style="width:274px;" 
                v-if="$route.query.info == 'custom'">
                <el-option 
                  v-for="item in companyList"
                  :key="item.company_id"
                  :label="item.name_zh || item.name_en"
                  :value="item.company_id"
                ></el-option>
              </el-select>
              <el-input 
                v-else 
                placeholder="" 
                v-model="baseform.company_name" 
                class="from_input from_input_variation"
                size="small" 
                :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="customer_id">
              <el-select v-model="baseform.customer_id" placeholder="请选择联系人" filterable :clearable="false" size="small"
              style="width:274px;" v-if="$route.query.info == 'custom'">
              <el-option v-for="item in customerList" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
              </el-select>
              <el-input v-else placeholder="请输入联系人" v-model="baseform.contacts" class="from_input from_input_variation"
              size="small" :disabled="true">
              </el-input>
              <el-button type="primary" size="small" @click="addCustomer" style="margin-left: 10px;" v-if="$route.query.info == 'custom'">添加联系人</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="card">
      <div class="header">
        <span class="sign"></span>
        订舱信息
      </div>
      <el-form label-width="170px" ref="baseformToWxp" :model="baseform" :rules="rules" :disabled="pagedisabled"
        label-position="left" style="padding-top:20px;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属公司" prop="oss_company_id">
              <el-select 
                v-model="baseform.oss_company_id" placeholder="请选择所属公司" 
                filterable 
                :clearable="false" 
                size="small" 
                style="width:274px;">
                <el-option 
                  v-for="item in ossCompanyList"
                  :key="item.id"
                  :label="item.name_zh || item.name_en"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="起运港" prop="from_port">
              <portSelect v-model="baseform.from_port" placeTitle="请输入起运港" :width="'274px'" :isDefault="true" clearable
                @input="from_port_input" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目的港" prop="dest_port">
              <portSelect v-model="baseform.dest_port" ref="resetportSelect" :width="'274px'" placeTitle="港口名称或代码"
                clearable @input="dest_port_input" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开航日期" prop="etd">
              <el-date-picker class="from_input from_input_variation" size="small" v-model="baseform.etd" type="date"
                placeholder="选择预计开航日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="wholeType === 1">
            <el-form-item label="船公司" prop="shipping_company">
              <shipCompany :placeTitle="'船司代码或中文名'" :width="'274px'" v-model="baseform.shipping_company"></shipCompany>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="wholeType === 0">
            <el-form-item label="内装仓库" prop="warehouse">
              <el-select v-model="baseform.warehouse" placeholder="请选择仓库" size="small" class="from_input from_input_variation">
                <el-option
                  v-for="item in warehouse_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="wholeType === 1">
          <el-col :span="12">
            <el-form-item label="箱型箱量" prop="weight">
              <el-tooltip v-if="baseform.weight" class="item" effect="light" :content="baseform.weight"
          placement="top-start">
          <el-input class="from_input from_input_variation" size="small" v-model="baseform.weight"
            :clearable="false" readonly :disabled="pagedisabled" @click.native="showWeightMod"
            placeholder="请输入箱型箱量"></el-input>
              </el-tooltip>
              <el-input class="from_input from_input_variation" size="small" v-else v-model="baseform.weight"
          :clearable="false" readonly :disabled="pagedisabled" @click.native="showWeightMod"
          placeholder="请输入箱型箱量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订舱代理" prop="booking_agent">
              <shipCompany :placeTitle="'订舱代理中文名'" :width="'274px'" :type="7" v-model="baseform.booking_agent">
              </shipCompany>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="货物类型" prop="cargo_type">
              <el-radio-group v-model="baseform.cargo_type" fill="#66b1ff">
                <el-radio :label="2">一般化工品(包括普通货物)</el-radio>
                <el-radio :label="1">危险品(含混装)</el-radio>
                <!-- <el-radio :label="3">混装货物(包含危险品和普货)</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="baseform.operational_requirements" rows="4" type="textarea" maxlength="300" show-word-limit
            placeholder=""></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="card">
      <div class="header">
        <span class="sign"></span>
        订舱资料
      </div>
      <el-form
        :model="form"
        status-icon
        ref="form"
        :disabled="pagedisabled"
        label-width="170px"
        label-position="left"
        style="padding-top:20px; width: 1200px"
      >
        <el-form-item label="海运出口委托书" prop="file1"
          :rules="[
            {
              required: true,
              message: '请上传海运出口委托书',
              trigger: 'change',
            },
          ]">
          <div class="file1">
            <div class="fileMsg">
              <p v-if="!form.file1.length">
                请上传海运出口委托书
              </p>
              <div v-else>
                <p v-for="(item, index) in form.file1" :key="index">
                  <span>{{ item.name }}</span>
                  <span
                    class="close"
                    @click="handleCha(1, index)"
                    v-if="!IsReject"
                    >x</span
                  >
                </p>
              </div>
            </div>
            <div class="btns" v-if="!IsReject">
              <fileUpload
                ref="uploadComponents1"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif"
                @selectFile="uploadFile($event, 1)"
                @uploadCompleteOSS="uploadCompleteOSS($event, 1)"
              >
                <div class="uploadBtn">本地上传</div>
              </fileUpload>
            </div>
          </div>
        </el-form-item>


       

        <el-form-item
          label="其他"
          prop="file6"
          v-if="config.indexOf('3') > -1"
          
        >
          <div class="file1">
            <div class="fileMsg">
              <p v-if="!form.file6.length && baseform.spell_type == 2">请上传（请将订舱其他资料以压缩包形式上传）</p>
              <p v-if="!form.file6.length && baseform.spell_type == 1">请上传（请将订舱其他资料以压缩包形式上传）</p>
              <div v-else>
                <p v-for="(item, index) in form.file6" :key="index">
                  <span>{{ item.name }}</span>
                  <span
                    class="close"
                    @click="handleCha(6, index)"
                    v-if="!IsReject"
                    >x</span
                  >
                </p>
              </div>
            </div>
            <div class="btns" v-if="!IsReject">
              <fileUpload
                ref="uploadComponents6"
                accept=".zip,.rar,.7z"
                @selectFile="uploadFile($event, 6)"
                @uploadCompleteOSS="uploadCompleteOSS($event, 6)"
              >
                <div class="uploadBtn">本地上传</div>
              </fileUpload>
            </div>
          </div>
        </el-form-item>

      </el-form>
      <el-dialog title="资料库" :visible.sync="dataBankDialog" width="800px" append-to-body>
        <selectDataBank v-if="dataBankDialog" :dataBankType="dataBankType" @uploadDataBank="uploadDataBank"
          @closeUploadDataBank="closeUploadDataBank"></selectDataBank>
      </el-dialog>
    </div>
    <div class="card">
      <div class="header">
        <span class="sign"></span>
        预录应收
      </div>
      <el-row class="tips" v-if="!pagedisabled">
        请根据与客户协商情况填写费用信息
      </el-row>
      <el-row v-if="!pagedisabled">
        <el-col :span="12">
          <el-button type="primary" size="small" @click="copyOrderFee">复制订单费用</el-button>
          <el-button type="primary" size="small" @click="copyQuotation">复制运价</el-button>
          <el-button type="primary" size="small" @click="addCost">添加费用</el-button>
        </el-col>
      </el-row>
      
      <!-- 添加调试区域，显示费用数据状态 -->
      <div class="debug-info" style="margin: 10px 0; padding: 10px; background-color: #edf8f1; border-radius: 4px;">
        <h3 style="color: #409EFF; margin-top: 0;">费用数据状态</h3>
        <p style="margin: 5px 0;">
          当前费用数量: <span style="font-weight: bold; color: #67C23A;">{{ costList && costList.length || 0 }}</span>
        </p>
        <div v-if="costList && costList.length > 0">
          <p style="margin: 5px 0;">最新添加的费用: {{ costList[costList.length-1].cost_name }}</p>
        </div>
        <div v-else>
          <p style="margin: 5px 0; color: #E6A23C;">暂无费用数据，请添加费用</p>
        </div>
      </div>
      
      <el-table :data="costList" :disabled="pagedisabled" v-show="costList.length"
        style="width: 100%; margin-top:20px; font-size:13px" max-height="550" border>
        <el-table-column label="费用名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ scope.row.cost_name | textFormat }}</template>
        </el-table-column>
        <el-table-column label="国内/国外" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.oversea == 2">国外</span>
            <span v-else-if="scope.row.oversea == 1">国内</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="计费单位" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!-- {{scope.row.measure_unit | textFormat}} -->
            {{ scope.row.measure_name_zh + '[' + scope.row.measure_code + ']' | textFormat }}
          </template>
        </el-table-column>
        <el-table-column label="币种" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.currency | textFormat }}
          </template>
        </el-table-column>
        <el-table-column label="数量" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.quantity | textFormat }}
          </template>
        </el-table-column>
        <el-table-column label="应收单价" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.unit_price | textFormat }}
          </template>
        </el-table-column>
        <el-table-column label="应收金额" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="amount">{{ scope.row.price | textFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" v-if="!pagedisabled" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="editRow(scope.$index, scope.row)" type="text" icon="el-icon-edit">
            </el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index, costList)" type="text" style="margin-left:20px"
              icon="el-icon-delete">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-button type="success" class="submitBtn" size="small" @click="handleSubmit" v-if="pageType == 1"
      :loading="submitLoading">提交委托
    </el-button>

    <el-dialog title="箱型箱量" :visible.sync="dialogFormVisible">
      <el-form :model="boxData" label-width="100px">
        <div class="boxDataItem" v-for="(item, index) in boxData.orders" :key="index">
          <el-form-item label="箱型" prop="box_model">
            <el-select v-model="item.box_model" clearable placeholder="请选择" size="small">
              <el-option v-for="item in boxModel" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="箱种" prop="box_type">
            <el-select v-model="item.box_type" clearable placeholder="请选择" size="small">
              <el-option v-for="item in boxType" :key="item.label" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量" prop="box_num">
            <el-input placeholder="请输入数量" v-model="item.box_num" oninput="value=value.replace(/[^\d]/g,'')" size="small"
              maxlength="2" max="20"></el-input>
          </el-form-item>
          <el-button type="text" size="small" style="margin-left:20px;margin-top: -20px;" @click="addboxDataItem"
            v-if="index == 0">添加</el-button>
          <el-button type="text" size="small" v-if="index != 0" style="margin-left:20px;margin-top: -20px;"
            @click="deleteboxDataItem(boxData.orders, index)">删除</el-button>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addboxDataItemConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加联系人弹窗 -->
    <el-dialog title="添加联系人" :visible.sync="contactDialogVisible" width="500px">
      <el-form :model="contactForm" :rules="contactRules" ref="contactForm" label-width="100px" size="small">
        <el-form-item label="联系人" prop="name">
          <el-input v-model="contactForm.name" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="职能" prop="position">
          <el-input v-model="contactForm.position" placeholder="请输入职能"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="mobile">
          <el-input v-model="contactForm.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="contactForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="contactForm.tel" placeholder="请输入电话号码"></el-input>
        </el-form-item>
        <el-form-item label="QQ" prop="qq">
          <el-input v-model="contactForm.qq" placeholder="请输入QQ号码"></el-input>
        </el-form-item>
        <el-form-item label="QQ归属" prop="qq_type">
          <el-radio-group v-model="contactForm.qq_type">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">公司</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contactDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitContact" :loading="contactSubmitLoading">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 添加订单费用选择弹窗 -->
    <orderAdd ref="orderAddRef" @selected="handleSelectedFees"></orderAdd>

    <costAdd ref="c_costAdd" @ret_cost="ret_cost" :spell_type="baseform.spell_type"></costAdd>

    <!-- 添加运价查询弹窗 -->
    <orderQuotationAdd ref="orderQuotationRef" @selected="handleSelectedFees"></orderQuotationAdd>
  </div>
</template>

<script>
import fileUpload from "~/baseComponents/fileUpload";
import selectDataBank from "~ymp/components/bookingSpace/uploadEntrustSon/selectDataBank";
import portSelect from "~ymp/components/common/portSelect"
import shipCompany from "~ymp/components/common/shipCompany"
import unnoSelect from "~ymp/components/common/unnoById"; // 这里存的是 dangerous_id 
import costAdd from "~bac/components/ymp/hYcostAdd";
import orderAdd from "~ymp/components/bookingSpace/orderSearchAdd";
import orderQuotationAdd from "~ymp/components/bookingSpace/orderQuotationAdd";
import quotationCost from "~bac/components/ymp/quotationCost";
import quotationCostLcl from "~bac/components/ymp/quotationCostLcl";
import shipCompanySearch from '~ymp/components/common/shipCompanySearch'
import { getFileType } from "~/baseUtils";
import {
  boxModel,
  boxType
} from "@/baseUtils/enumValue";
export default {
  props: {
    config: {
      type: String,
      default: "1,2,3,4",
    },
  },
  components: { 
    fileUpload, 
    selectDataBank, 
    portSelect, 
    unnoSelect, 
    shipCompany, 
    shipCompanySearch, 
    costAdd, 
    quotationCost, 
    quotationCostLcl,
    orderAdd,
    orderQuotationAdd
  },
  data() {
    // 自定义邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      if (value && !/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(value)) {
        callback(new Error('请输入正确的邮箱格式'));
      } else {
        callback();
      }
    };
    
    // 自定义手机号验证规则
    const validateMobile = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码格式'));
      } else {
        callback();
      }
    };
    
    return {
      wholeType: 0, // 添加整箱/拼箱类型标识 0-拼箱，1-整箱
      dataBankDialog: false,
      fileRequired: false,
      boxModel,
      boxType,
      dialogFormVisible: false,
      customerList: [],
      companyList: [],
      ossCompanyList: [],
      baseform: {
        entrusting_unit: '',
        company_id: null,
        customer_id: null,
        contacts: '',
        company_name: '',
        oss_company_id: null,
        spell_type: 1, // 默认整箱
        cargo_type: 1, // 默认危险品
        from_port: 4179,
        dest_port: '',
        shipping_company: '',
        booking_agent: '',
        local_service: [],
        net_weight: '',
        is_big: 0,
        etd: "",
        weight: "",//箱型箱量
        job_refer_no: "", //客户委托号-----业务参考号
        warehouse: "", //内装仓库id
        //危险品信息de数据
        special_goods: [
          {
            un_no: "",
            dangerous_id: "",
            classify: "",
            cargo_name_en: "",
            deleted: 0,
            gross_weight: null,
            out_packing_quantity: null,
            packing_group: "",
          }
        ],
      },
      form: {
        file1: [], //1-海运委托书
        file6: [], //6-其他
      },
      need: false,
      IsReject: false,
      submitLoading: false,
      pageLoading: false,
      pagedisabled: false,
      serviceLocalType: [{
        value: "1",
        label: "订舱"
      }, {
        value: "2",
        label: "仓库内装"
      }, {
        value: "3",
        label: "门点装箱/提货"
      }, {
        value: "4",
        label: "报关申报"
      }, {
        value: "5",
        label: "自拉自送"
      }, {
        value: "6",
        label: "海事申报"
      }, {
        value: "7",
        label: "21天免用箱"
      }],
      rules: {
        etd: [{ required: true, message: ' ', trigger: 'blur' }],
        cargo_type: [{ required: true, message: ' ', trigger: 'blur' }],
        company_id: [{ required: true, message: " ", trigger: "blur" }],
        customer_id: [{ required: true, message: " ", trigger: "blur" }],
        from_port: [{ required: true, message: " ", trigger: "blur" }],
        dest_port: [{ required: true, message: " ", trigger: "blur" }],
        oss_company_id: [{ required: true, message: " ", trigger: "change" }],
      },
      queryInfo: {
        from_port_name: null,
        from_port_id: 4179, // 默认起运港为上海
        dest_port_name: null,
        dest_port_id: null,
      },
      costList: [],
      pageType: 1, // 1 新增  2 编辑
      pageDetail: {}, // 查询的详情数据
      userID: '', // 客户id 
      companyID: '', // 客户公司id
      warehouse_list: [],
      boxData: {
        orders: [
          {
            box_model: '',
            box_type: '',
            box_num: '',
            is_cargo_master: 0
          }
        ]
      },
      // 新增联系人相关
      contactDialogVisible: false,
      contactSubmitLoading: false,
      contactForm: {
        name: '',
        position: '',
        mobile: '',
        email: '',
        tel: '',
        qq: '',
        qq_type: 1,
      },
      contactRules: {
        name: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
        mobile: [
          { required: false, message: '请输入手机号码', trigger: 'blur' }, // 修改为非必填
          { validator: validateMobile, trigger: 'blur' }
        ],
        email: [
          { required: false, message: '请输入邮箱', trigger: 'blur' }, // 修改为非必填
          { validator: validateEmail, trigger: 'blur' }
        ]
      },
      companyLoading: false,
    };
  },

  mounted() {
    // 从URL参数获取wholeType
    if (this.$route.query.type !== undefined) {
      this.wholeType = parseInt(this.$route.query.type);
      // 根据wholeType设置baseform中的spell_type
      // 注意：wholeType为1时表示整箱，对应spell_type为1；wholeType为0时表示拼箱，对应spell_type为2
      this.spell_type = this.wholeType === 1 ? 1 : 2;
    }
    
    this.getWarehouseListFunc();
    this.getOssCompanyList();
    this.getCompanyList();
    if (this.$route.query.id != undefined) {
      this.pageType = 2;
      this.getDetails()
    } else if (this.$route.query.info == 'custom') { //自定义客户
      //this.getaffairsOptions();
    } else {
      let queryInfo = JSON.parse(decodeURIComponent(this.$route.query.info));
      this.userID = queryInfo.user_id;
      this.baseform.company_name = queryInfo.company_name_zh;
      this.baseform.contacts = queryInfo.name_zh;

      this.baseform.company_id = queryInfo.company_id;
      this.baseform.customer_id = queryInfo.user_id;
      this.spell_type = 2; // 默认拼箱
    }
  },
  methods: {
    // 添加切换整箱/拼箱类型的方法
    switchBookingType() {
      this.wholeType = this.wholeType === 1 ? 0 : 1;
      // 更新表单中的拼箱类型
      this.spell_type = this.wholeType === 1 ? 1 : 2;
      
      // 更新路由参数但不刷新页面
      this.$router.replace({
        query: { 
          ...this.$route.query,
          type: this.wholeType
        }
      });

      this.costList = [];
      
      // 切换类型时可能需要清空或重置一些数据
      if (this.wholeType === 1) {
        // 整箱特有设置
        this.baseform.warehouse = '';
      } else {
        // 拼箱特有设置
        this.baseform.weight = '';
        this.baseform.shipping_company = '';
        this.baseform.booking_agent = '';
      }
    },
    
    fillData(e) {
      if (e) {
        // 填充数据时也要设置wholeType
        if (e.spell_type) {
          // spell_type为1时表示整箱(wholeType=1)，为2时表示拼箱(wholeType=0)
          this.wholeType = e.spell_type === 1 ? 1 : 0;
        }
        
        this.baseform = {
          company_id: e.company_name_zh || '',
          company_name: e.company_name_zh || '',
          contacts: e.user_name || '',
          oss_company_id: e.oss_company_id || null,
          spell_type: e.spell_type || 1, // 默认整箱
          cargo_type: e.cargo_type ? Number(e.cargo_type) : 1, // 默认危险品
          from_port: e.pol || 4179,
          dest_port: e.delivery_place || '',
          shipping_company: e.shipping_company || '',
          booking_agent: e.booking_agent || '',
          local_service: e.local_service ? e.local_service.split(',') : [],
          warehouse: e.warehouse || '',
          etd: e.etd ? e.etd * 1000 : '',
          operational_requirements: e.operational_requirements || '',
        }
        this.boxData.orders = e.container_info ? JSON.parse(e.container_info) : '';
        this.costList = e.fee_list ? JSON.parse(e.fee_list) : [];
        this.form.file1 = e.attorney || [];
        this.form.file6 = e.other_files || [];
        this.userID = e.user_id;
        this.pageLoading = false;
        this.pagedisabled = true;
        if (e.container_info && e.container_info != '[]') {
          var weight = '';
          this.boxData.orders.forEach(item => {
            weight += `${item.box_num ? item.box_num + '*' : ''}${item.box_model == 1 ? '20`' : item.box_model == 2 ? '40`' : item.box_model == 3 ? '45`' : '-'} ${item.box_type ? item.box_type : ''}，`
          })
          this.baseform.weight = weight ? weight.slice(0, -1) : '';
        } else {
          this.boxData.orders = [{
            box_model: '',
            box_type: '',
            box_num: '',
            is_cargo_master: 0
          }]
        }
        let special_goods_null = [
          {
            un_no: "",
            classify: "",
            cargo_name_en: "",
            deleted: 0,
            gross_weight: null,
            out_packing_quantity: null,
            packing_group: "",
          },
        ]
        this.baseform.special_goods = e.fba_special_goods_list.length ? e.fba_special_goods_list : special_goods_null;
        this.$forceUpdate();
      }
    },
    getuserFunc(val) {
      let objFilter = {};
      objFilter = this.customerList.find((item) => {
        return item.id == val
      })
      this.baseform.entrusting_unit = objFilter.company_name_zh;
      this.baseform.contacts = objFilter.name_zh;
      this.companyID = objFilter.company_id;
    },
    addCustomer() {
      // 1. 检查是否选择了委托单位
      if (!this.baseform.company_id) {
        this.$message.warning('请先选择委托单位');
        return;
      }
      
      // 重置联系人表单
      this.contactForm = {
        name: '',
        position: '',
        mobile: '',
        email: '',
        tel: '',
        qq: '',
        qq_type: 1,
      };
      
      // 显示添加联系人弹窗
      this.contactDialogVisible = true;
      
      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.contactForm) {
          this.$refs.contactForm.clearValidate();
        }
      });
    },
    // 提交联系人
    submitContact() {
      this.$refs.contactForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        
        this.contactSubmitLoading = true;
        
        try {
          const params = {
            company_id: this.baseform.company_id,
            name: this.contactForm.name,
            position: this.contactForm.position,
            mobile: this.contactForm.mobile,
            email: this.contactForm.email,
            telephone: this.contactForm.tel,
            qq: this.contactForm.qq,
            qq_belong: this.contactForm.qq_type,
            identity: 1
          };
          
          const res = await this.$store.dispatch('API_bookingSpace/add_company_contacts', params);
          
          if (res.success) {
            this.$message.success('添加联系人成功');
            this.contactDialogVisible = false;
            
            // 刷新联系人列表
            this.getCustomerList();
          } else {
            this.$message.error(res.message || '添加联系人失败');
          }
        } catch (error) {
          console.error('添加联系人失败:', error);
          this.$message.error('添加联系人出现异常，请稍后再试');
        } finally {
          this.contactSubmitLoading = false;
        }
      });
    },
    getCompanyList() {
      let params = {
        company_name: this.baseform.entrusting_unit,
        nopage: 0,
      }
      this.$store.dispatch("API_bookingSpace/company_associateSearch", params).then((res) => {
        if (res.success) {
          this.companyList = res.data;
        } else {
          this.companyList = [];
        }
      });
    },
    getCustomerList() {
      let params = {
        company_id: this.baseform.company_id,
        identity: 1,
        is_forbidden: 0,
        nopage: 1,
      }
      this.$store.dispatch("API_bookingSpace/company_contacts", params).then((res) => {
        if (res.success) {
          this.customerList = res.data;
        } else {
          this.customerList = [];
        }
      });
    },
    getOssCompanyList() {
      let params = {
        user_id: this.USER_INFO.id,
        user_type: 1
      }
      this.$store.dispatch("API_bookingSpace/getUserOssCompanyList", params).then((res) => {
        if (res.success) {
          this.ossCompanyList = res.data;
          
          // 添加处理逻辑：根据USER_INFO.company_name_zh匹配公司列表
          if (this.USER_INFO.company_name_zh && this.ossCompanyList.length > 0) {
            // 找到匹配的公司
            const matchedCompany = this.ossCompanyList.find(item => 
              item.name_zh === this.USER_INFO.company_name_zh
            );
            
            // 如果找到匹配的公司，设置baseform.oss_company_id
            if (matchedCompany) {
              this.baseform.oss_company_id = matchedCompany.id;
            }
          }
        } else {
          this.ossCompanyList = [];
        }
      });
    },
    getaffairsOptions() {
      let params = {
        company_status: 2,
        nopage: 1,
        user_id: this.USER_INFO.id
      }
      this.$store.dispatch("baseConsole/cooperative_client_list", params).then((res) => {
        this.customerList = res.data;
      });
    },
    unnoSelectFunc(e, i) {
      if (e) {
        this.baseform.special_goods[i].un_no = e.un_no || '';
        this.baseform.special_goods[i].dangerous_id = e.id || '';
        this.baseform.special_goods[i].classify = `${e.classify} + ${e.subsidiary_risks}` || '';
        this.baseform.special_goods[i].packing_group = e.packing_group || '';
        this.$forceUpdate();
      }
    },
    ret_cost(e) { // 添加/编辑 费用 的 事件函数
      let isExistence = this.costList.some((item => {
        if (item.cost_name == e.obj.cost_name) {
          return true
        }
      }))
      if (e.index || e.index == 0) {
        this.$message.success("修改成功！")
        this.$set(this.costList, e.index, e.obj)
      } else {
        if (isExistence) {
          this.$message.warning("该费用已存在，添加失败！")
          return false;
        } else {
          this.costList.push(e.obj)
          this.$message.success("添加成功！")
        }
      }
    },
    editRow(index, row) {
      this.$refs.c_costAdd.openDialog(index, JSON.parse(JSON.stringify(row)))
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    from_port_input(val, name_en) {
      if (val === '') val = null
      let num = Number(val)
      if (!isNaN(num) || val === '') {
        this.queryInfo.from_port_id = val
        this.queryInfo.from_port_name = name_en || 'SHANGHAI'
      }
    },
    dest_port_input(val, name_en) {
      if (val === '') val = null
      let num = Number(val)
      if (!isNaN(num) || val === '') {
        this.queryInfo.dest_port_id = val
        this.queryInfo.dest_port_name = name_en
      }
      this.$nextTick(() => {
        this.$refs.baseform.clearValidate('dest_port');
      })
    },
    addCost() {
      // 添加判断，确保引用存在
      if (this.$refs.c_costAdd) {
        this.$refs.c_costAdd.openDialog(null, null);
      } else {
        console.error('costAdd 组件引用不存在');
        this.$message.error('加载费用组件失败，请刷新页面重试');
      }
    },
    getQuotationLcLCost() {
      if (this.baseform.dest_port && this.baseform.from_port) {
        this.$refs.quotationCostLclRef.openDialog(Object.assign(this.baseform, this.queryInfo))
      } else {
        this.$message.warning("请先完善基本港口信息!")
      }
    },
    getQuotationCost() {
      if (this.baseform.dest_port && this.baseform.from_port) {
        if (this.baseform.weight) {
          this.$refs.quotationCostRef.openDialog(Object.assign(this.baseform, this.queryInfo), JSON.stringify(this.boxData.orders))
        } else {
          this.$message.warning("请先完善箱型箱量信息!")
        }
      } else {
        this.$message.warning("请先完善基本港口信息!")
      }
    },
    async getDetails() {
      this.pageLoading = true;
      let data = await this.$store.dispatch(
        "API_bookingSpace/seaOrderDetails",
        {
          id: this.$route.query.id,
        }
      );
      if (data.success) {
        this.pageDetail = JSON.parse(JSON.stringify(data.data));
        this.fillData(this.pageDetail);
      } else {
        this.pageLoading = false;
        this.$message.error('操作失败')
      }
    },
    async getWarehouseListFunc() {
      this.pageLoading = true;
      let data = await this.$store.dispatch(
        "API_bookingSpace/getWarehouseList",
        {
          is_abroad: 0,
          nopage: 1
        }
      );
      if (data.success) {
        this.warehouse_list = data.data || [];
      } else {
        this.$message.error('操作失败')
      }
      this.pageLoading = false;
    },
    // 重新订舱
    reBooking() {
      this.pageType = 1;
      this.pagedisabled = false;
      this.$nextTick(() => {
        this.$refs.resetportSelect.handleInitValue();
      })
      this.form = {
        file1: [], //1-海运委托书
        file6: [], //6-其他
      }
    },
    async handleSubmit(RemoveID) {
      let uploadEntrust = await this.uploadEntrustSaveFn(RemoveID)
      let basicInfo = await this.basicInfosaveFn()
      if (uploadEntrust && basicInfo) {
        let parmas = Object.assign(uploadEntrust, basicInfo)
        parmas.create_from = 1 // 创建来源：1-PC，2-小程序
        parmas.fee_list = JSON.stringify(this.costList)
        if (parmas.spell_type == 1 && this.costList.length < 1) {
          this.$message.warning("请至少添加一项费用!")
          return false;
        }
        this.submitLoading = true
        if (this.$route.query.info == 'custom') {
          // parmas.customer = this.companyID;
          //parmas.user_id = this.userID
        } else if (this.$route.query.info) {
          let queryInfo = JSON.parse(decodeURIComponent(this.$route.query.info));
          parmas.customer = queryInfo.company_id
          parmas.user_id = queryInfo.user_id
        } else {
          parmas.customer = this.pageDetail.customer
          parmas.user_id = this.pageDetail.user_id
        }
        let res = {}
        if (RemoveID == 'edit') {
          parmas.id = this.pageDetail.id;
          res = await this.$store.dispatch("API_bookingSpace/sellMakeEntrustSave", parmas);
          // res = await this.$store.dispatch("API_bookingSpace/sellMakeEntrustEdit", parmas);
        } else {
          res = await this.$store.dispatch("API_bookingSpace/sellMakeEntrustSave", parmas);
        }
        if (res.success) {
          this.submitLoading = false
          if (RemoveID == 'edit') {
            this.$message.success("编辑成功!")
            this.getDetails();
          } else {
            this.$router.push({
              path: '/bookingSpaceTitle',
              query: {
                id: res.data.order_id,
                job_no: res.data.job_no,
                status: 4,
                pageType: 3, // 销售帮客户订舱 类型
              }
            })
          }
        }
      }
    },
    addGoods() {
      this.baseform.special_goods.push({
        un_no: "",
        dangerous_id: "",
        classify: "",
        cargo_name_en: "",
        deleted: 0,
        gross_weight: null,
        out_packing_quantity: null,
        packing_group: "",
      })
      this.$forceUpdate();
    },
    deleteGoods(rows, index) {
      rows.splice(index, 1);
      this.$forceUpdate();
    },
    deleteboxDataItem(rows, index) {
      rows.splice(index, 1);
    },
    addboxDataItem() {
      this.boxData.orders.push({
        box_model: '',
        box_type: '',
        box_num: '',
        is_cargo_master: 0
      })
    },
    addboxDataItemConfirm() {
      let isAdd = true;
      this.boxData.orders.forEach((item => {
        if (item.box_model == '' || item.box_type == '' || item.box_num == '') {
          isAdd = false
        }
      }))
      if (!isAdd) {
        this.$message.warning("请先完善信息！")
        return false;
      }
      var weight = '';
      this.boxData.orders.forEach(item => {
        // weight += `${item.box_num}*${ item.box_model == 1 ? '20`' : item.box_model == 2? '40`' : '45`'} ${item.box_type}，`
        weight += `${item.box_num ? item.box_num + '*' : ''}${item.box_model == 1 ? '20`' : item.box_model == 2 ? '40`' : item.box_model == 3 ? '45`' : '-'} ${item.box_type ? item.box_type : ''}，`
      })
      this.baseform.weight = weight ? weight.slice(0, -1) : '';
      this.dialogFormVisible = false;
      this.$refs.baseform.clearValidate('weight')
    },
    async addCostList(list) {
      let that = this;
      let filterable = list.map((item) => {
        return {
          cost_name: item.fee_name,
          oversea: item.oversea ? item.oversea + '' : '1',
          measure_unit: item.measure_id,
          currency: item.currency,
          quantity: item.nums, // 数量
          price: item.receivable_price, // 应收金额
          unit_price: item.receivable_unit_price, // 应收单价
          measure_name_zh: item.measure_name_zh,
          measure_code: item.measure_code
        };
      });
      this.costList = this.costList.concat(filterable);
      this.$message.success('添加成功')
    },
    async basicInfosaveFn() {
      return new Promise((resolve, reject) => {
        this.$refs["baseform"].validate((valid) => {
          if (valid) {
            let parmas = {
              oss_company_id: this.baseform.oss_company_id || '',
              customer: this.baseform.company_id,
              user_id: this.baseform.customer_id,
              pol: this.baseform.from_port,
              spell_type: this.spell_type,
              delivery_place: this.queryInfo.dest_port_id,
              etd: this.$moment(this.baseform.etd).unix(),
              warehouse: this.baseform.warehouse || '',
              shipping_company: this.baseform.shipping_company || '',
              booking_agent: this.baseform.booking_agent || '',
              container_info: JSON.stringify(this.boxData.orders),
              cargo_type: this.baseform.cargo_type,
              sale_mobile: this.USER_INFO.mobile,
              creator: this.USER_INFO.id,
              operational_requirements: this.baseform.operational_requirements || ''
            };
            resolve(parmas);
          } else {
            resolve(false);
          }
        });
      });
    },
    // 在线提交
    async uploadEntrustSaveFn(RemoveID = false) {
      return new Promise((resolve, reject) => {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            let files_info = []
            if (this.form.file1.length > 0) {
              files_info = files_info.concat(this.form.file1)
            }
            if (this.form.file6.length > 0) {
              files_info = files_info.concat(this.form.file6)
            }
            if (this.pageType == 2 && RemoveID == true) {
              files_info.forEach(item => {
                if (item.id) {
                  delete item.id
                }
              })
            }
            let parmas = {
              files_info: JSON.stringify(files_info)
            }
            resolve(parmas)
          } else {
            resolve(false)
          }
        });
      })
    },
    uploadFile(val, index) {
      let obj = {
        name: val[0].name,
        file_type: index == 6 ? index - 1 : index,
        size: (val[0].size / 1024).toFixed(2),
        format: getFileType(val[0].name),
      };
      if (`file${index}` == 'file1' && this.form[`file${index}`].length > 0) {
        this.$message.warning("海运委托书只能有一个");
        return;
      }
      if (this.form[`file${index}`].length >= 1) {
        this.$message.warning("只能上传一个压缩包");
        return;
      } else {
        // Proceed with upload if within limits
        let file = Object.assign({}, obj);
        this.form[`file${index}`].push(file);
        this.$refs[`uploadComponents${index}`].uploadFileToOss();
      }
    },
    uploadCompleteOSS(val, index) {
      this.$refs["form"].clearValidate([`file${index}`]);
      this.form[`file${index}`][this.form[`file${index}`].length - 1].url =
        val.url;
    },
    handleCha(index, num) {
      if (this.pagedisabled) {
        return
      }
      this.form[`file${index}`].splice(num, 1);
    },
    showWeightMod() {
      if (this.pagedisabled) {
        return;
      }
      this.dialogFormVisible = true;
    },
    handleDtatBank(val) {
      this.dataBankType = val;
      this.dataBankDialog = true;
    },
    uploadDataBank(row, type) {
      this.$refs["form"].clearValidate([`file${type}`]);
      if (this.form[`file${type}`].length < 6) {
        let num = this.form[`file${type}`].findIndex(
          (item) => item.attachment_id == row.attachment_id
        );
        if (num == -1) {
          this.form[`file${type}`].push(Object.assign({}, row));
          this.dataBankDialog = false;
        } else {
          this.$message.warning("不能重复选择资料");
        }
      } else {
        this.$message.warning("不能超过6个");
      }
    },
    //  关闭资料库
    closeUploadDataBank() {
      this.dataBankDialog = false;
    },
    // 复制订单费用
    copyOrderFee() {
      // 直接调用组件的open方法打开订单选择弹窗
      if (this.$refs.orderAddRef) {
        this.$refs.orderAddRef.open();
      } else {
        console.error('orderAdd 组件引用不存在');
        this.$message.error('加载订单组件失败，请刷新页面重试');
      }
    },
    //复制运价
    copyQuotation() {
      // 准备传递给运价查询组件的参数
      const params = {
        from_port_id: this.queryInfo.from_port_id,
        from_port_name: this.queryInfo.from_port_name,
        dest_port_id: this.queryInfo.dest_port_id,
        dest_port_name: this.queryInfo.dest_port_name,
        spell_type: this.spell_type,
      };
      
      // 调用组件的打开方法
      if (this.$refs.orderQuotationRef) {
        this.$refs.orderQuotationRef.open(params);
      } else {
        console.error('orderQuotationAdd 组件引用不存在');
        this.$message.error('加载运价组件失败，请刷新页面重试');
      }
    },
    // 根据关键词获取公司列表
    getCompanyListByKeyword(query) {
      if (query.length < 1) {
        this.companyList = [];
        return;
      }
      
      this.companyLoading = true;
      
      // 使用防抖，避免频繁调用接口
      if (this.companySearchTimer) {
        clearTimeout(this.companySearchTimer);
      }
      
      this.companySearchTimer = setTimeout(() => {
        let params = {
          company_name: query,
          nopage: 0,
        };
        
        this.$store.dispatch("API_bookingSpace/company_associateSearch", params)
          .then((res) => {
            if (res.success) {
              this.companyList = res.data;
            } else {
              this.companyList = [];
            }
          })
          .catch((error) => {
            console.error('获取公司列表失败:', error);
            this.$message.error('获取公司列表失败，请稍后重试');
            this.companyList = [];
          })
          .finally(() => {
            this.companyLoading = false;
          });
      }, 300); // 300ms的防抖延迟
    },
    
    // 原有的getCompanyList方法可以保留，但不再直接调用，而是作为初始化使用
    getCompanyList() {
      let params = {
        company_name: '',
        nopage: 0,
      }
      this.$store.dispatch("API_bookingSpace/company_associateSearch", params).then((res) => {
        if (res.success) {
          this.companyList = res.data;
        } else {
          this.companyList = [];
        }
      });
    },
    
    // 处理选择的费用
    handleSelectedFees(fees) {
      console.log('customerBooking 接收到的费用数据:', fees);
      
      if (!fees || !fees.length) {
        this.$message.warning('未接收到任何费用数据');
        return;
      }

      let filterable = fees.map((item) => {
        return {
          cost_name: item.fee_name || item.cost_name,
          oversea: item.oversea ? item.oversea + '' : '1',
          measure_unit: item.measure_unit_id || item.measure_unit,
          currency: item.currency_code || item.currency,
          quantity: item.quantity, // 数量
          price: item.include_tax || item.price, // 应收金额
          unit_price: item.unit_rate || item.unit_price, // 应收单价
          measure_name_zh: item.measure_unit_code || item.measure_name_zh,
          measure_code: item.measure_unit_name || item.measure_code,
        };
      });
      
      // 确保 costList 已初始化为数组
      if (!this.costList) {
        this.costList = [];
      }
      
      // 将接收到的费用添加到 costList
      this.costList = [...this.costList, ...filterable];
      
      // 强制更新视图以确保新数据被显示
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      
      this.$message.success(`成功添加 ${fees.length} 项费用到预录应收列表`);
    },
  }
};
</script>

<style scoped lang="less">
.booking {
  padding: 20px 40px;
  margin: -10px;
  background-color: #fff;

  .el-form-item {
    margin-bottom: 22px !important;
  }
}

.auditbox {
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 18px 2px rgba(213, 213, 213, 0.55);
  min-height: 140px;

  .content {
    margin-top: 18px;
    display: flex;
    flex-direction: row;

    .el-button {
      height: 30px;
    }

    div {
      width: 600px;
      margin-left: 20px;
    }
  }
}

.card {
  background: #ffffff;
  padding: 30px;
  margin-top: 20px;
  box-shadow: 0px 2px 18px 2px rgba(213, 213, 213, 0.55);

  .header {
    height: 60px;
    line-height: 60px;
    margin-left: -30px;
    margin-top: -30px;
    margin-right: -30px;
    border-bottom: 1px solid #d9d9d9;

    .sign {
      width: 2px;
      height: 14px;
      background-color: #22D00E;
      vertical-align: middle;
      display: inline-block;
      margin-right: 24px;
    }
  }
}

.uploadBtn {
  color: #415058;
  width: 80px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  line-height: 32px;
}

.uploadBtn2 {
  color: #415058;
  width: 94px;
  height: 32px;
  background: #f0f2f5;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  line-height: 32px;
  text-align: center;
  margin-left: 12px;
  cursor: pointer;
}

.file1 {
  display: flex;
  justify-content: space-between;

  .btns {
    display: flex;
    align-items: center;
  }

  .fileMsg {
    span {
      color: #999;
    }

    .close {
      padding-left: 20px;
      cursor: pointer;
      font-weight: 900;
      color: #000;
    }
  }
}

.from_input {
  width: 274px;
}

.from_input_variation {
  margin-top: 2px;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #67c23a;
  background: #67c23a;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #67c23a;
  background: #67c23a;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #67c23a;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: #606266;
}

.tips {
  margin-top: 30px;
  margin-bottom: 20px;
  color: #333;
}

.submitBtn {
  background-color: #91BE42;
  border-color: #91BE42;
  margin-top: 20px;
  margin-bottom: 75px;
}

// 2022 - 07 - 19 新增
.boxDataItem {
  display: flex;
}

.deletegoods {
  margin-top: 6px;
}

.booking-header {
  margin-bottom: 20px;
  
  .booking-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    line-height: 32px; /* 与按钮高度对齐 */
  }
}
</style>